export enum SessionRecordingMode {
  CONTINUOUS = 'CONTINUOUS',
  MANUAL = 'MANUAL',
}
